import React, { Component } from 'react';
import Header from '../Header/Header';

export default class About extends Component {
  render() {
    return (
      <div data-testid="about-page">
        <Header page="About page" />
      </div>
    );
  }
}
